import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiblingPriceValidatorService {
  private siblingPricesSubject = new BehaviorSubject<number[]>([]);
  siblingPrices$ = this.siblingPricesSubject.asObservable();

  updatePrice(index: number, value: number): void {
    const siblingPrices = this.siblingPricesSubject.getValue();
    siblingPrices[index] = value;
    this.siblingPricesSubject.next([...siblingPrices]);
  }

  initializePrices(prices: number[]): void {
    this.siblingPricesSubject.next(prices);
  }

  removePrices(index: number): void {
    this.siblingPricesSubject.getValue().splice(index, 1);
    this.siblingPricesSubject.next(this.siblingPricesSubject.getValue());
  }
}
